import React from 'react';

import { BaseSVG } from '@/shared/assets/icons/base-icon/base-icon.styled';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';
import { useBaseIconColor } from '@/shared/assets/icons/base-icon/use-base-icon-color';

export const BaseIcon: React.FC<TBaseIcon> = ({
  ref,
  variant,
  color,
  size,
  children,
  ...rest
}) => {
  const _color = useBaseIconColor(variant, color);

  return (
    <BaseSVG $color={_color} $size={size} ref={ref} {...rest}>
      {children}
    </BaseSVG>
  );
};
